import './Visual.css';
export var visualContainerCSS = '_113to8a0-2-0-1';